// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Ordering = require("@rescript/runtime/lib/js/Stdlib_Ordering.js");
let Primitive_object = require("@rescript/runtime/lib/js/Primitive_object.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Utils__AttachmentUrl = require("./Utils__AttachmentUrl.bs.js");

function join(separator, lastSeparatorOpt, list) {
  let lastSeparator = lastSeparatorOpt !== undefined ? lastSeparatorOpt : separator;
  return Stdlib_List.reduceWithIndex(list, "", (acc, x, i) => {
    if (i !== 0) {
      if (i === (Stdlib_List.length(list) - 1 | 0)) {
        return acc + (lastSeparator + x);
      } else {
        return acc + (separator + x);
      }
    } else {
      return x;
    }
  });
}

function findFirst(predicate, _xs) {
  while (true) {
    let xs = _xs;
    if (xs === 0) {
      return;
    }
    let hd = xs.hd;
    if (predicate(hd)) {
      return Primitive_option.some(hd);
    }
    _xs = xs.tl;
    continue;
  };
}

function pseudoJoin(joiner, lastJoiner, xs) {
  if (xs === 0) {
    return /* [] */0;
  }
  let tail = xs.tl;
  let hd = xs.hd;
  if (tail !== 0) {
    if (tail.tl !== 0) {
      return {
        hd: hd,
        tl: {
          hd: joiner,
          tl: pseudoJoin(joiner, lastJoiner, tail)
        }
      };
    } else {
      return {
        hd: hd,
        tl: {
          hd: Stdlib_Option.getOr(lastJoiner, joiner),
          tl: {
            hd: tail.hd,
            tl: /* [] */0
          }
        }
      };
    }
  } else {
    return {
      hd: hd,
      tl: /* [] */0
    };
  }
}

function stripNones(x) {
  return Stdlib_List.filterMap(x, x => x);
}

let List = {
  join: join,
  findFirst: findFirst,
  pseudoJoin: pseudoJoin,
  stripNones: stripNones
};

function uniq(input, fn) {
  return Stdlib_Array.reduce(input, [], (newArr, value) => {
    if (newArr.some(a => fn(a) === fn(value))) {
      return newArr;
    } else {
      return [value].concat(newArr);
    }
  });
}

function pseudoJoin$1(joiner, lastJoiner, arr) {
  return Stdlib_List.toArray(pseudoJoin(joiner, lastJoiner, Stdlib_List.fromArray(arr)));
}

function joinWith(joinStr, arr) {
  return arr.join(joinStr);
}

function joinWithLabels(separator, arr) {
  return arr.join(separator);
}

function sort(cmp, arr) {
  let cp = arr.slice();
  if (cmp !== undefined) {
    cp.sort(cmp);
  } else {
    cp.sort((a, b) => Stdlib_Ordering.fromInt(Primitive_object.compare(a, b)));
  }
  return cp;
}

function stripNones$1(x) {
  return Stdlib_Array.filterMap(x, x => x);
}

function join$1(separator, lastSeparatorOpt, list) {
  let lastSeparator = lastSeparatorOpt !== undefined ? lastSeparatorOpt : separator;
  return Stdlib_Array.reduceWithIndex(list, "", (acc, x, i) => {
    if (i !== 0) {
      if (i === (list.length - 1 | 0)) {
        return acc + (lastSeparator + x);
      } else {
        return acc + (separator + x);
      }
    } else {
      return x;
    }
  });
}

let $$Array = {
  uniq: uniq,
  pseudoJoin: pseudoJoin$1,
  joinWith: joinWith,
  joinWithLabels: joinWithLabels,
  sort: sort,
  stripNones: stripNones$1,
  join: join$1
};

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function trimInput(s) {
  return s.replace(/[^\w\s]/g, " ").replace(/\s+/g, " ").trim();
}

let nbsp = '\u00a0';

let upperHalfBlock = '\u2580';

let lowerHalfBlock = '\u2584';

let lastCommaRe = /,(?!.*,)/gmi;

function enumerate(strings) {
  return Stdlib_List.toArray(strings).join(", ").replace(lastCommaRe, " and");
}

function formatAsPhone(value) {
  let value$1 = value.replace(/\D/g, "");
  if (value$1.length === 0) {
    return "";
  }
  let first = value$1.substring(0, 3);
  let middle = value$1.substring(3, 6);
  let last = value$1.substring(6, 10);
  if (value$1.length > 6) {
    return `(` + first + `) ` + middle + ` - ` + last;
  } else if (value$1.length > 3) {
    return `(` + first + `) ` + middle;
  } else {
    return `(` + first;
  }
}

let $$String = {
  capitalize: capitalize,
  trimInput: trimInput,
  nbsp: nbsp,
  upperHalfBlock: upperHalfBlock,
  lowerHalfBlock: lowerHalfBlock,
  lastCommaRe: lastCommaRe,
  enumerate: enumerate,
  formatAsPhone: formatAsPhone
};

function ofOption(error, opt) {
  if (opt !== undefined) {
    return {
      TAG: "Ok",
      _0: Primitive_option.valFromOption(opt)
    };
  } else {
    return {
      TAG: "Error",
      _0: error
    };
  }
}

let Result = {
  ofOption: ofOption
};

let UUID = {};

let Float = {};

function setCurrentRef(reactRef, value) {
  reactRef.current = value;
}

let React = {
  setCurrentRef: setCurrentRef
};

let makeAttachmentUrl = Utils__AttachmentUrl.makeAttachmentUrl;

let baseAttachmentUrl = Utils__AttachmentUrl.baseAttachmentUrl;

let $$Promise;

let Regex;

exports.makeAttachmentUrl = makeAttachmentUrl;
exports.baseAttachmentUrl = baseAttachmentUrl;
exports.List = List;
exports.$$Array = $$Array;
exports.$$String = $$String;
exports.Result = Result;
exports.UUID = UUID;
exports.Float = Float;
exports.React = React;
exports.$$Promise = $$Promise;
exports.Regex = Regex;
/* Utils__AttachmentUrl Not a pure module */
